@if (glossaryUrl) {<ptl-glossary-search [glossaryUrl]="glossaryUrl"></ptl-glossary-search>}